<template>
  <div>
    <com-dialog :visible.sync="visible" append-to-body title="检验密码">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
        class="demo-ruleForm"
      >
        <el-form-item label="密码" prop="password">
          <el-input v-model="ruleForm.password" placeholder="" type="password"></el-input>
        </el-form-item>
      </el-form>
      <div class="mt-15px flex justify-end">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" :disabled="disabled"
          >确定</el-button
        >
      </div>
    </com-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      ruleForm: {},
      disabled: false,
      rules: {
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    open() {
      this.ruleForm = {}
      this.visible = true
    },
    close() {
      this.visible = false
    },
    submitForm(formName) {
      // eslint-disable-next-line consistent-return
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.ruleForm.password)
          this.close()
        }
      })
    }
  }
}
</script>
